import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export class ApLicensePlateValidator {
    /**
     * Validate that control has a valid license plate value
     */
    public static validate(control: AbstractControl): ValidationErrors {
        return Validators.compose([
            Validators.pattern(/^[A-Za-z0-9]{1,3}[a-zA-Z0-9-\s]+[A-Za-z0-9]{1,3}$/),
            ApLicensePlateValidator.validateLicensePlate
        ])(control);
    }

    private static validateLicensePlate(control: AbstractControl): ValidationErrors {
        if (!control.value) {
            return null;
        }
        return control.value.replace(/[-\s]/g, '').length !== 6 ? { length: true } : null;
    }
}
